export default __webpack_public_path__ + "static/media/Roboto-Italic.2a1b89d7.ttf";